import { render, staticRenderFns } from "./addWrad.vue?vue&type=template&id=625d1f52&scoped=true&"
import script from "./addWrad.vue?vue&type=script&lang=js&"
export * from "./addWrad.vue?vue&type=script&lang=js&"
import style0 from "./addWrad.vue?vue&type=style&index=0&id=625d1f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625d1f52",
  null
  
)

export default component.exports